module.exports = __webpack_public_path__ + "img/unionPayDownload.1caee8b2.png";